import React from 'react';
import { useIntl } from 'react-intl';
import appTheme from 'shared/constants/theme.json';
import OptionsResult from './OptionsResult';
import { withChartSettings } from './withChartSettings';

import messages from './messages';

const SentimentResult = ({ question, segments, addToReport, chartSettings, ...props }) => {
  const { formatMessage } = useIntl();
  const sentimentSegments = segments.filter(segment => segment.sentiments?.length).map(segment => ({
    ...segment,
    values: segment.sentiments.map(tag => ({
      value: tag.count,
      itemStyle: { color: appTheme[tag.text] },
      id: tag.text,
      name: (messages[tag.text] && formatMessage(messages[tag.text])) ?? tag.text,
    })),
  }));

  return (
    <OptionsResult
      {...props}
      question={{
        ...question,
        segments: sentimentSegments,
        translateNames: false,
      }}
      chartSettings={withChartSettings(chartSettings, 'stacked')}
      toolbox={{
        chartTypes: ['bar', 'pie', 'stacked'],
      }}
      addToReport={addToReport && ((data) => {
        addToReport({
          chartSettings: {
            ...data?.chartSettings,
            fieldResultType: 'sentiment',
          },
        });
      })}
    />
  );
};

export default SentimentResult;
